import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
    ADD_MOBILE_TOWER_DESIGN_STARTING,
    ADD_MOBILE_TOWER_DESIGN_SUCCESS,
    ADD_MOBILE_TOWER_DESIGN_ERROR,
} from '../../constants/actionTypes';

export default function addTowerDesignReducer(state = initialState.addTowerDesigns, action) {
    switch (action.type) {
        case ADD_MOBILE_TOWER_DESIGN_STARTING: {
            const newState = clone(state);
            newState.saving = true;
            newState.saved = false;
            return newState;
        }

        case ADD_MOBILE_TOWER_DESIGN_SUCCESS: {
            const { data } = action;
            const newState = clone(state);
            newState.saving = false;
            newState.saved = true;
            newState.error = null;

            newState.newMobileTowerDesign = data.design;
            return newState;
        }

        case ADD_MOBILE_TOWER_DESIGN_ERROR: {
            const newState = clone(state);
            newState.saving = false;
            newState.saved = false;
            newState.error = action.err;
            return newState;
        }

        default: {
            return state;
        }
    }
}